<template>
  <div class="dev-credit">
    <span>Desenvolvido por</span>
    <a href="https://juliodevelop.online" target="_blank" rel="noopener noreferrer">
      <img src="/juliodevelop-logo.png" alt="JulioDevelop" />
      <span class="credit-label">JulioDevelop</span>
    </a>
  </div>
</template>

<script>
export default { name: 'DevCredit' }
</script>

<style scoped>
.dev-credit {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 11px;
  color: #888;
  padding: 16px 12px;
}
.dev-credit a {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
  color: #555;
  transition: opacity 0.2s ease;
  font-weight: 600;
}
.dev-credit a:hover { opacity: 0.8; }
.dev-credit img { width: 18px; height: 18px; }
</style>
